import { Box, Button, Container, Flex, Text } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';
import WomenLookingAtScreens from '@/assets/images/presentation/women-looking-at-screens.png';

export const PurpleGradientSection = () => {
  const { t } = useTranslation();

  return (
    <Box
      bgImage="linear-gradient(180deg, rgba(170, 138, 247, 0.75) 0%, rgba(170, 138, 247, 0.00) 100%)"
      bgRepeat="no-repeat"
      py={{ base: 6, lg: 16 }}
    >
      <Container>
        <Flex flexDirection={{ base: 'column', lg: 'row' }} alignItems="center" gap={4} maxW="1000px" mx="auto">
          <Flex flex={1} justifyContent="center">
            <Image src={WomenLookingAtScreens} alt="Women looking at screens" />
          </Flex>
          <Flex flex={1} justifyContent="center" flexDirection="column" maxW="491px">
            <Text>{t('hybridEventsPage.purpleSectionText')}</Text>
            <Button
              as={Link}
              href="/contact-us/conferences"
              variant="solid"
              alignSelf="flex-start"
              mt={{ base: 7, lg: 14 }}
              rightIcon={<ArrowIcon />}
            >
              {t('newEventPage.getStarted')}
            </Button>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};
